// import enums
import { EndOfEmploymentSettlementEnums } from 'components/admin-portal/CLA/CLASettings/CLASettings.enums';

export const settlementPrefixMap: Record<
  keyof typeof EndOfEmploymentSettlementEnums,
  'payOut' | 'settle' | 'transfer' | 'none'
> = {
  [EndOfEmploymentSettlementEnums.PAY_OUT]: 'payOut',
  [EndOfEmploymentSettlementEnums.SETTLE]: 'settle',
  [EndOfEmploymentSettlementEnums.TRANSFER]: 'transfer',
  [EndOfEmploymentSettlementEnums.NONE]: 'none'
};
